const getters = {
    marketingcampaign: (state) => state.marketingcampaign,
    marketingcampaignid: (state) => state.marketingcampaignid,
    loading: (state) => state.loading,
   
};

export default getters;